import { gql } from '@apollo/client';

export const fetchSubscriptionsForShipToParty = gql`
  query fetchSubscriptionsForShipToParty(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    invoiceGroupsForShipToPartyId(id: $id) {
      id
      shipToPartyBillingGroupIds
      productSubscriptions(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          id
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          edition
          cloudSiteHostname
          billedUsers
          trial
          isSandbox
          isApp
        }
      }
    }
  }
`;
